module.exports = __webpack_public_path__ + "static/how-card-red-dee41eb78d42ef9a28ebf74d7f76b05b.svg";